<template lang="pug">
  section

    el-breadcrumb
      el-breadcrumb-item Marketing
      el-breadcrumb-item
        b Benefícios

    SearchList(
      context="benefit"
      :service="benefitService"
    )
      template(slot="tableRows")

        el-table-column(prop="id" label="ID" width="80" sortable)

        el-table-column(prop="title" label="Nome" :show-overflow-tooltip="true" sortable)

        el-table-column(prop="active", label="Ativo", width="100", sortable)
          template(scope="scope")
            span(v-if="scope.row.active" style="color: #67C23A") Ativo
            span(v-else style="color: #F56C6C") Inativo

        el-table-column(prop="expiresAt" label="Expira em" width="160" sortable)
          template(slot-scope="scope")

            span(v-if="scope.row.expiresAt && (new Date(scope.row.expiresAt)).getTime() > (new Date()).getTime()" style="color: #67C23A") {{ fromSystemDate(scope.row.expiresAt ? scope.row.expiresAt + 'T00:00:00-0300' : null) }}
            span(v-else style="color: #F56C6C") {{ fromSystemDate(scope.row.expiresAt ? scope.row.expiresAt + 'T00:00:00-0300' : null) }}
</template>
<script setup>
import moment from 'moment';

import BenefitService from '@/services/promotions/BenefitService';

import SearchList from '@/components/list/SearchList.vue';

const benefitService = BenefitService

const fromSystemDate = (value) => {
  return value ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;
}
</script>
